document.addEventListener("DOMContentLoaded", (event) => {
  gsap.registerPlugin(ScrollTrigger)
  let endScroll = window.innerWidth > 768 ? '80% 70%' : '100% 50%';
  const timeline = gsap.timeline({
    scrollTrigger: {
        trigger: '.page-banner-animated',
        start: '20px 100px', // when the top of the trigger hits the top of the viewport
        end: endScroll,
        scrub: 1,
        markers: false
    }
  })
  let pageWidth = $('.page-width').innerWidth() - 40
  timeline.from('.page-banner-animated img', { width: pageWidth, y: 40 });

  const timeline2 = gsap.timeline({
    scrollTrigger: {
      trigger: '.img-tile',
      start: '100px 60%',
      end: '130% 80%',
      scrub: 1,
      markers: false,
    }
  })
  timeline2.from('.img-tile .svg1', { clipPath:"inset(0 100% 0 0%)" }, 'sametime');
  timeline2.from('.img-tile .svg2', { clipPath:"inset(0 0% 0 100%)" }, 'sametime');
 });